import React, { Component } from "react";
import { ToastContainer, toast } from "react-toastify";

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      employeeCode: "",
      password: "",
    };
  }

  formatEmployeeCode = (value) => {
    const employeeCode = value.toUpperCase();

    if (employeeCode.includes("-")) {
      return employeeCode;
    }

    return employeeCode.replace(/^([A-Z]+)(\d.*)$/, "$1-$2");
  };

  handleChangeEmployeeCode = (e) => {
    this.setState({
      employeeCode: this.formatEmployeeCode(e.target.value),
    });
  };

  handleChangePassword = (e) => {
    this.setState({
      password: e.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const { employeeCode, password } = this.state;

    if (!employeeCode.trim() || !password.trim()) {
      return toast.error("Please provide both employee code and password.");
    }

    this.props.onLogin(employeeCode, password);
  };

  render() {
    return (
      <>
        <ToastContainer position={toast.POSITION.TOP_RIGHT} />
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "24px",
            background:
              "linear-gradient(135deg, #f4f8ff 0%, #eef4f1 45%, #f9fbfd 100%)",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              maxWidth: "420px",
              padding: "40px 32px",
              borderRadius: "24px",
              backgroundColor: "rgba(255, 255, 255, 0.96)",
              boxShadow: "0 24px 60px rgba(15, 23, 42, 0.12)",
              border: "1px solid rgba(148, 163, 184, 0.18)",
            }}
          >
            <div
              style={{
                textAlign: "center",
                marginBottom: "28px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "14px",
                  marginBottom: "18px",
                }}
              >
                <div
                  style={{
                    width: "70px",
                    height: "70px",
                    borderRadius: "22px",
                    background:
                      "linear-gradient(145deg, #27568a 0%, #1f63af 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 16px 30px rgba(39, 86, 138, 0.22)",
                    padding: "7px",
                  }}
                >
                  <img
                    src="/assets/img/business_logo.png"
                    alt="Alliance Business Logo"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "70px",
                    height: "70px",
                    borderRadius: "18px",
                    backgroundColor: "#f8fafc",
                    border: "1px solid rgba(148, 163, 184, 0.2)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px",
                  }}
                >
                  <img
                    src="/assets/img/ic_launcher_foreground.png"
                    alt="HRM App Icon"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>
              </div>
              <h1
                style={{
                  margin: 0,
                  fontSize: "32px",
                  fontWeight: 700,
                  color: "#0f172a",
                }}
              >
                HRM System
              </h1>
              <p
                style={{
                  margin: "10px 0 0 0",
                  color: "#64748b",
                  fontSize: "14px",
                }}
              >
                Sign in to continue to your workspace
              </p>
            </div>

            <form onSubmit={this.handleSubmit} style={{ width: "100%" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }}
              >
                <div>
                  <label
                    htmlFor="login-employee-code"
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      color: "#334155",
                      fontSize: "14px",
                      fontWeight: 600,
                    }}
                  >
                    Employee Code
                  </label>
                  <input
                    id="login-employee-code"
                    type="text"
                    className="form-control"
                    value={this.state.employeeCode}
                    onChange={this.handleChangeEmployeeCode}
                    placeholder="Enter your employee code"
                    style={{
                      minHeight: "46px",
                      width: "100%",
                      display: "block",
                      boxSizing: "border-box",
                      borderRadius: "12px",
                      border: "1px solid #cbd5e1",
                      padding: "10px 14px",
                    }}
                  />
                </div>

                <div>
                  <label
                    htmlFor="login-password"
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      color: "#334155",
                      fontSize: "14px",
                      fontWeight: 600,
                    }}
                  >
                    Password
                  </label>
                  <input
                    id="login-password"
                    type="password"
                    className="form-control"
                    value={this.state.password}
                    onChange={this.handleChangePassword}
                    placeholder="Enter your password"
                    autoComplete="current-password"
                    style={{
                      minHeight: "46px",
                      width: "100%",
                      display: "block",
                      boxSizing: "border-box",
                      borderRadius: "12px",
                      border: "1px solid #cbd5e1",
                      padding: "10px 14px",
                    }}
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{
                    width: "100%",
                    minHeight: "48px",
                    marginTop: "8px",
                    borderRadius: "12px",
                    border: "1px solid #27568a",
                    backgroundColor: "#27568a",
                    boxShadow: "0 14px 30px rgba(39, 86, 138, 0.22)",
                    fontWeight: 600,
                  }}
                >
                  Login
                </button>
              </div>
            </form>

            {this.props.error && (
              <p
                style={{
                  color: "#dc2626",
                  marginTop: "16px",
                  marginBottom: 0,
                  textAlign: "center",
                }}
              >
                {this.props.error}
              </p>
            )}
          </div>
        </div>
      </>
    );
  }
}
